import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return ['promo_code'];
  }


  initialize(){
  }

  promoKey(event){
    event.preventDefault();

    if(event.keyCode == 13){
      this.applyPromo();
    }
  }


  applyPromo(event) {
    event.preventDefault();

    let token = document.getElementsByName('csrf-token')[0].getAttribute('content')
    axios.defaults.headers.common['X-CSRF-Token'] = token

    const options = {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      data: {promo_code: this.promo_codeTarget.value},
      url: "checkout/add_promotion.json"
    };
    axios(options)
        .then(function(response){
          Turbolinks.visit(response.data.visit);
        }).catch(function(err){
           // t.errorsTarget.innerHTML = err.response.data.errors;
           // t.errorsTarget.style.display = "block";
        });
  }
}
